//react...
import React from "react";

import "./Examinations.styles.css";

const SaeedMousivand = () => {
  return (
    <div className="examination-container">
      <div className="box">
        <div className="name"> Mr. Saeed Mousivand </div>

        <div className="score"> score: 99 / 100 </div>
      </div>
    </div>
  );
};

export default SaeedMousivand;
